import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { onMfaEnrollmentRequired, onSessionExpired } from '../lib/api-client';
import { loginPathFor } from '../lib/safe-next';
import { isPublicRoute } from './public-routes';

/** Connects API-client session events to navigation and the query cache. */
export function SessionBridge() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryClient = useQueryClient();
  const locationRef = useRef(location);

  useEffect(() => {
    locationRef.current = location;
  });

  useEffect(() => {
    const offExpired = onSessionExpired(() => {
      const { pathname, search } = locationRef.current;
      if (isPublicRoute(pathname)) {
        return;
      }
      void navigate(loginPathFor(`${pathname}${search}`), { replace: true });
      queryClient.clear();
    });
    const offMfa = onMfaEnrollmentRequired(() => {
      if (locationRef.current.pathname !== '/security') {
        void navigate('/security?mfa=required');
      }
    });
    return () => {
      offExpired();
      offMfa();
    };
  }, [navigate, queryClient]);

  return null;
}
